import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import moment from 'moment';
import Animate from '../../../shared/animation';
import { notFound, showMoreRows, mapTableSortHeaders } from '../../../shared/table-helpers';
import { baseUrl } from '../../../../config/route-entry-point';
import { Link } from 'react-router';

lessRequire('modules/tickets/list/components/table-tickets.less');

const TicketsTable = ({
	tableRows,
	tableHeaders,
	sortByColumn,
	columnSorting,
	showMore,
	isCanNotMoveToNext,
	intl
}) => {
	return (
		<Animate>
			<table className="dashboard-table tickets-table">
				<thead className="dashboard-table__head font-proxima-nova-semibold">
					<tr>
						{mapTableSortHeaders({
							headers: tableHeaders,
							columnSorting,
							sortByColumn,
							intl
						}).map((header, i) => <th key={i}>{header}</th>)}
					</tr>
				</thead>
				<tbody className="dashboard-table__body">
					{ (!tableRows || !tableRows.length) ? notFound(intl)
						: tableRows.map(row => (
							<tr key={row.id} className={cn({
								closed: !!row.closed_at || row.status === 'closed'
							})}>
								<td className="id">
									<Link to={baseUrl(`tickets/${row.id}/`)}>#{row.id}</Link>
								</td>
								<td className="datetime">
									{ moment(row.updated_at).format('DD.MM.YYYY') }
									<i>{ moment(row.updated_at).format('HH:mm') } </i>
								</td>
								<td className="title">
									<Link to={baseUrl(`tickets/${row.id}/`)}>{row.title}</Link>
									{ row.category === 'admin_ticket' && <span className="staff-info">{intl('От администрации')}</span>}
								</td>
								<td className="answer">
									{ row.total_posts }
									{ row.new_posts > 0 ? <span>+{ row.new_posts }</span> : null }
								</td>
								<td className="ticket-status">{ getStatus(row, intl) }</td>
							</tr>
						)) }
					{!isCanNotMoveToNext && tableRows.length && showMore ? showMoreRows(showMore, 'TicketsTable', intl) : null}
				</tbody>
			</table>
		</Animate>
	);
};

const getStatus = (row, intl) => {
	if (row.status === 'closed' || !!row.closed_at) {
		return <span className="status status-inactive">{intl('Тема закрыта')}</span>;
	} else if (parseInt(row.new_posts)) {
		return <span className="status status-active">{intl('Новое сообщение')}</span>;
	}
	return <span className="status status-pause">{intl('Ожидание ответа')}</span>;
};

TicketsTable.propTypes = {
	tableRows: PropTypes.array,
	tableHeaders: PropTypes.array,
	sortByColumn: PropTypes.func,
	columnSorting: PropTypes.object,
	showMore: PropTypes.func,
	isCanNotMoveToNext: PropTypes.bool,
	intl: PropTypes.func
};

export default TicketsTable;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/tickets/list/components/table-tickets.js